<template>
  <div class="content">
    <div class="head">
      <div class="title">
        <span>{{userInfo.cp_name}} </span>
        <!-- <span class="pact" @click="toPact"><span>合作协议</span><img :src="public_path + '/static/images/arrow_right.svg'" alt=""></span> -->
      </div>
      <div class="info" :style="{'background-image': 'url(' + publicImg + '/bg_1.png)'}">
        <div>
          <span class="name">{{userInfo.contact}}</span>
          <span class="tel">{{userInfo.mobile}}</span>
        </div>
        <div>
          <span class="id">服务商ID: <span>{{userInfo.id}}</span></span>
          <span class="city">服务城市: <span>{{userInfo.province_name}}-{{userInfo.city_name}}</span></span>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="item" @click="toIncome">
        <div class="icon">
          <img :src="public_path + '/static/images/purse_icon.svg'" alt="">
        </div>
        <span>我的收入</span>
        <div class="right">
          <img :src="public_path + '/static/images/arrow_right.svg'" alt="">
        </div>
      </div>
      <div class="item" @click="toEquipment">
        <div class="icon">
          <img :src="public_path + '/static/images/equipment_state_icon.svg'" alt="">
        </div>
        <span>我的设备（{{userInfo.dev_num}}）</span>
        <div class="right">
          <img :src="public_path + '/static/images/arrow_right.svg'" alt="">
        </div>
      </div>
      <div class="item" @click="toOrderHistory">
        <div class="icon">
          <img :src="public_path + '/static/images/order_icon.svg'" alt="">
        </div>
        <span>我的订单（{{userInfo.order_num}}）</span>
        <div class="right">
          <img :src="public_path + '/static/images/arrow_right.svg'" alt="">
        </div>
      </div>
      <div class="item" @click="toShare">
        <div class="icon">
          <img :src="public_path + '/static/images/share.svg'" alt="">
        </div>
        <span>我要分享</span>
        <div class="right">
          <img :src="public_path + '/static/images/arrow_right.svg'" alt="">
        </div>
      </div>
      <div class="item" @click="logout">
        <div class="icon">
          <img :src="public_path + '/static/images/sign_out_icon.svg'" alt="">
        </div>
        <span>退出登录</span>
        <div class="right">
          <img :src="public_path + '/static/images/arrow_right.svg'" alt="">
        </div>
      </div>
    </div>
    <div class="banner" @click="toBuy">
      <img :src="publicImg + '/banner@3x.png'" alt="" class="banner">
    </div>
  </div>
</template>
<script>
import { getProdcut, getInfo } from '@/http/api'
import { hostUrl } from '../../http/env.js'
export default {
  data () {
    return {
      userInfo: {},
      public_path: process.env.PUBLICK_PATH,
      publicImg: 'http://picture.eclicks.cn/kaojiazhao/public/rem'
    }
  },
  methods: {
    toShare () {
      this.$router.push({
        path: '/share'
      })
    },
    toPact () {
      this.$router.push({
        path: '/cooperationPact'
      })
    },
    logout () {
      localStorage.clear()
      this.$router.push({
        path: '/login'
      })
    },
    getUserInfo () {
      let data = {
        token: localStorage.token
      }
      getInfo(data).then(res => {
        console.log(res)
        if (res.code === 0) {
          console.log(res.data.state)
          if (+res.data.state === 0 || +res.data.state === 10) {
            this.$router.push({
              path: '/publicity'
            })
          } else if (+res.data.state === 11) {
            this.$router.push({
              name: 'Checking',
              params: {agent: res.data}
            })
          } else {
            this.userInfo = res.data
            console.log(this.userInfo)
            localStorage.setItem('userInfo', JSON.stringify(this.userInfo))
          }
        } else {
          console.log('请求服务商信息失败')
          localStorage.clear()
          this.$router.push({
            path: '/login'
          })
        }
      })
    },
    getProdcut () {
      getProdcut().then(res => {
        console.log(res)
      })
    },
    toIncome () {
      this.$router.push({
        path: '/income'
      })
    },
    toEquipment () {
      this.$router.push({
        path: '/equipment'
      })
    },
    toOrderHistory () {
      this.$router.push({
        path: `/ecmall/orders?channel_no=agent`
      })
    },
    toBuy () {
      this.$router.push({
        path: '/ecmall?channel_no=agent'
      })
    }
  },
  mounted () {
    let shareParams = {
      timeline: '超级教练路考仪-服务商后台',
      title: '超级教练路考仪-服务商后台',
      desc: '申请成为超级教练路考仪服务商即可快速领取设备，每月收入尽收眼底！',
      imgUrl: 'http://picture.eclicks.cn/kaojiazhao/public/rem/share_img.jpg',
      link: `${hostUrl}/agent/`
    }
    this.$nextTick(() => {
      _wx.setMenuShare({
        timeline: shareParams.timeline,
        title: shareParams.title,
        desc: shareParams.desc,
        imgUrl: shareParams.imgUrl,
        link: shareParams.link,
        success () {
          console.log('分享成功')
        },
        fail (err) {
          console.log('分享失败')
          console.log(err)
        }
      })
    })
    // localStorage.setItem('token', '8a373e4a6ebcbe6ded0b06bfca9bbc9f')
    // localStorage.setItem('token', '1a44245e3cc373120a9ff088096fcf1c')
    // localStorage.setItem('token', '0de995432ede76de0ab0b0ce8b142c04')
    let token = localStorage.token
    let userInfo = localStorage.userInfo
    if (!token) {
      this.$router.push({
        path: '/login'
      })
    }
    this.userInfo = userInfo ? JSON.parse(userInfo) : {}
    this.getProdcut()
    this.getUserInfo()
  }
}
</script>
<style lang="scss" scoped>
.content {
  font-size: 0;
  color: #333;
}
.head {
  width: 100%;
  .title {
    margin-top: .34rem;
    padding: 0 .3rem;
    font-size: .38rem;
    font-weight: 600;
    // display: flex;
    align-items: center;
    .pact {
      margin-top: .1rem;
      font-size: .26rem;
      font-weight: 400;
      float: right;
      display: flex;
      align-items: center;
      img {
        width: .14rem;
        height: .24rem;
        margin-left: .2rem;
      }
    }
  }
  .info {
    padding: .35rem 0;
    margin-top: .3rem;
    background-repeat: no-repeat;
    background-size: 100% auto;
    box-sizing: border-box;
    >div {
      font-size: .26rem;
      color: #fff;
      margin-left: .8rem;
      margin-bottom: .2rem;
      .name {
        font-size: .34rem;
        font-weight: 500;
      }
      .tel {
        margin-left: .70rem;
      }
      .id {
        span {
          font-weight: 600;
          margin-left: .1rem;
        }
      }
      .city {
        margin-left: .5rem;
        span {
          font-weight: 600;
          margin-left: .1rem;
        }
      }
    }
  }
}
.body {
  padding: 0 .3rem;
  box-sizing: border-box;
  margin-top: .3rem;
  .item {
    width: 100%;
    font-size: .3rem;
    font-weight: 600;
    height: 1.14rem;
    line-height: 1.14rem;
    display: -webkit-flex;
    display: flex;
    align-items: center;
    .icon {
      text-align: left;
      margin-top: .16rem;
      img {
        padding-right: .2rem;
        width: .38rem;
        height: .38rem;
      }
    }
    .right {
      flex: 1;
      text-align: right;
      img {
        width: .14rem;
        height: .25rem;
        float: right;
      }

    }
  }
}
.banner {
  margin-top: .3rem;
  width: 100%;
  img {
    width: 100%;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/Index.vue